export default __webpack_public_path__ + "static/media/finansbank.ce249c74.png";